export default __webpack_public_path__ + "static/vote-d7483d4d6034774b7ce07c73607422e0.webp";